import { isEmpty, forEach } from "ramda";

export default function updateArrangementsDiscount() {
  const arrayArrangements = document.getElementsByClassName("to-calculate-discount");
  let arrangementsPrice = 0;

  if (!isEmpty(arrayArrangements ?? [])) {
    forEach((element) => {
      if (!isEmpty(element?.value ?? "")) {
        arrangementsPrice += parseFloat(element.value.replace(",", "."));
      }
    }, arrayArrangements);
  }

  return Number.parseFloat(arrangementsPrice);
}
